import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

export const TEXT_KEYS = {
    FOOTER_LEGAL_INFORMATION: 'footer__legal-information',
    FOOTER_PRIVACY_POLICY: 'footer__privacy-policy',
    FOOTER_TERMS_OF_USE: 'footer__terms-of-use',
    FOOTER_CUSTOMER_SUPPORT: 'footer__customer-support',
    FOOTER_COPYRIGHT: 'footer__copyright',
    FOOTER_DO_NOT_SELL_MY_INFO: 'footer__do-not-sell-my-info',
    FOOTER_MANAGE_COOKIES: 'footer__manage-cookies'
};

export const FOOTER_LOGO_CLASSNAMES = {
    UBISOFT: 'sitegen-ubisoft-logo',
    CONNECT: 'sitegen-ubisoft-connect-logo',
    UCLUB: 'sitegen-ubisoft-club-logo',
    USTORE: 'sitegen-ubisoft-store-logo',
    EPIC: 'sitegen-epic-logo',
    PS4: 'sitegen-ps4-logo',
    PS5: 'sitegen-ps5-logo',
    XBOX1: 'sitegen-xbox-one-logo',
    XBOXX: 'sitegen-xbox-series-x-logo',
    STADIA: 'sitegen-stadia-logo',
    SWITCH: 'sitegen-switch-logo',
    LUNA: 'sitegen-luna-logo'
};

export const enum ANALYTICS_ACTION {
    UBISOFT = 'ubisoft.com',
    UPLAY = 'Uplay',
    UBISOFT_STORE = 'Ubisoft Store',
    EPICGAMES = 'epicgames.com',
    PLAYSTATION = 'playstation.com',
    XBOX = 'xbox.com',
    LUNA = 'amazon.com/luna',
    STADIA = 'stadia.com',
    NINTENDO = 'nintendo.com',
    CUSTOMER_SUPPORT = 'Customer support',
    TERMS_OF_USE = 'Terms of use',
    TERMS_AND_CONDITIONS = 'Referral terms and conditions',
    LEGAL_INFORMATION = 'Legal information',
    PRIVACY_POLICY = 'Privacy policy',
    DONT_SELL_MY_INFO = 'Do not sell my Personal information',
    INIT_PRIVACY_OPTIONS = 'INIT_PRIVACY_OPTIONS'
}

export const LEGALS_LINKS_ANALYTICS_ATTRIBUTES = {
    category: CATEGORY.ACTION,
    location: 'footer',
};
